import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { PoliticaVinculacion } from "../_models/politica-vinculacion";
import { AutenticacionService } from './autenticacion.service';

@Injectable({
  providedIn: "root",
})
export class PoliticasVinculacionesService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasVinculaciones";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listadoPoliticasVinculaciones() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as PoliticaVinculacion[]));
  }

  listadoPoliticasVinculacionesHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as PoliticaVinculacion[]));
  }

  listadoPoliticas(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/pol")
      .pipe(map((res) => res as PoliticaVinculacion[]));
  }
  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as PoliticaVinculacion));
  }

  listadoIdPolitica(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica)
      .pipe(map((res) => res as PoliticaVinculacion[]));
  }

  listadoIdPoliticaEnabled(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica + "/enabled" )
      .pipe(map((res) => res as PoliticaVinculacion[]));
  }

  crear(regCrear: PoliticaVinculacion) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as PoliticaVinculacion));
  }

  actualizar(regActualizar: PoliticaVinculacion) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as PoliticaVinculacion));
  }

  bulk(registros: PoliticaVinculacion[]) {
    registros.map((s: PoliticaVinculacion) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + "/bulk", registros)
      .pipe(map((res) => res as PoliticaVinculacion[]));
  }
}
